var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnUploadImg = function SvgIcnUploadImg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7H33C34.6569 7 36 8.34315 36 10V28.9993C36 28.9998 36 29.0002 36 29.0007V30C36 31.6569 34.6569 33 33 33H7C5.34315 33 4 31.6569 4 30V25.9958C4 25.9957 4 25.9956 4 25.9955V10C4 8.34315 5.34315 7 7 7ZM6 26.41V30C6 30.5523 6.44772 31 7 31H33C33.5523 31 34 30.5523 34 30V29.4141L26.6417 22.0542L22.7702 24.8182C22.0215 25.3527 21.0126 25.3043 20.3202 24.7207L20.1942 24.605L13.9997 18.4142L6 26.41ZM34 26.5854L28.0561 20.6401L27.9301 20.5244C27.2377 19.9405 26.2284 19.8919 25.4796 20.4265L21.6081 23.1905L15.4142 16.9997L15.2869 16.883C14.5006 16.2218 13.3265 16.2606 12.5864 16.999L6 23.5822V10C6 9.44772 6.44772 9 7 9H33C33.5523 9 34 9.44772 34 10V26.5854ZM31 14.5C31 15.8807 29.8807 17 28.5 17C27.1193 17 26 15.8807 26 14.5C26 13.1193 27.1193 12 28.5 12C29.8807 12 31 13.1193 31 14.5Z",
    fill: "#C6C8CC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnUploadImg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_upload_img.41d8e525.svg";
export { ForwardRef as ReactComponent };